import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './contact-us-item.component.scss';
var ContactUsItem = /** @class */ (function (_super) {
    tslib_1.__extends(ContactUsItem, _super);
    function ContactUsItem(element) {
        return _super.call(this, element) || this;
    }
    ContactUsItem.prototype.init = function () { };
    ContactUsItem.prototype.bindEvents = function () { };
    return ContactUsItem;
}(Base));
export { ContactUsItem };



//////////////////
// WEBPACK FOOTER
// ./components/contact-us-item/contact-us-item.component.ts
// module id = 216
// module chunks = 0